import React, { useContext, useEffect, useState } from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import PMoneyTransactions from "../../Components/Transactions/PMoneyTransactions";
import PMTransactionsCategorizedChart from "../../Components/Transactions/PMTransactionsCategorizedChart";
import ajaxBank from "../../util/remote/ajaxBank";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import RateContext from "../../Context/RateContext";
import Commissions from "../../Components/Transactions/Commissions";
function PocketMoneyPage() {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const todayFormatted = new Date().toLocaleDateString('en-US', options);
  const [pmCollectionsToday, setPMCollectionsToday] = useState(false);
  const {transactionHighlights} = useContext(RateContext);
  

  useEffect(() => {
        getPMCollectionsToday();
  
    }, []);
 
  const getPMCollectionsToday = async () => {
      const server_response = await ajaxBank.fetchPMTransactionsToday();
      if (server_response.status === "OK") {
        setPMCollectionsToday(server_response.details.totals);
      } else {
        setPMCollectionsToday(false);
      }
  };
  return (
    <AppContainer title="Pocket Money Transactions">
        <div className="row row-sm">
          <div className="col-lg-4">
              <div className="card custom-card">
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Transactions Today ({todayFormatted})</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Transaction Type</th>
                        
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Cash Amount</Tooltip>}>
                        <th ><i className="fa fa-sack-dollar" style={{color: "black"}}></i></th></OverlayTrigger>
                      </tr>
                      <tr>
                        <td>Student Deposits</td>
                        <td> UGX. {pmCollectionsToday ? pmCollectionsToday.deposit.total_c :"0"}</td>
                      </tr>
                      <tr>
                        <td>Canteen Purchases</td>
                        <td> UGX. {pmCollectionsToday? pmCollectionsToday.purchase.total_c: "0"}</td>
                      </tr>
                     
                      <tr>
                        <td>Student Withdrawals</td>
                        <td> UGX. {pmCollectionsToday? pmCollectionsToday.withdraw.total_c: "0"}</td>
                      </tr>
                      <tr>
                        <td>PM Conversions</td>
                        <td> UGX. {pmCollectionsToday? pmCollectionsToday.conversion.total_c :"0"}</td>
                      </tr>
                       <tr>
                        <td>Card Activations</td>
                        <td> UGX. {pmCollectionsToday? pmCollectionsToday.card_activation.total_c: "0"}</td>
                      </tr>
                      <tr>
                        <td>Wristband Activations</td>
                        <td> UGX. {pmCollectionsToday? pmCollectionsToday.wristband_activation.total_c: "0"}</td>
                      </tr>
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
           
           
          
        </div>
        <div className="col-lg-8 col-md-12 col-12 col-sm-12 mt-lg-0 mt-sm-4">
                <div class="card">
                  <div class="card-body">

                    <PMTransactionsCategorizedChart/>
                   
                  </div>
                </div>      
        </div>
        
      </div>
        {/* <div className="row">
            <div className="col-lg-12 col-md-12 mt-3">
            <div className="card custom-card">
                    <div className="card-body map-card">
                        <PMoneyTransactions/>
                    </div>
                </div>
            </div>
        </div> */}
        <div className="row">
              <div className="col-lg-12 col-md-12 mt-3">
                      <div className="card height-auto">
                        <div className="card-body">
                          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Row>
                              <Col sm={12}>
                                <Nav variant="pills" className="flex-row mb-1">
                                  <Nav.Item>
                                    <Nav.Link size="sm" eventKey="first">
                                      Pocket Money Transactions{" "}
                                    </Nav.Link>
                                  </Nav.Item>

                                  <Nav.Item>
                                    <Nav.Link size="sm" eventKey="second">
                                      Commissions{" "}
                                    </Nav.Link>
                                  </Nav.Item>
                                 
                                  <Nav.Item>
                                    <Nav.Link size="sm" eventKey="third">
                                      Transaction Highlights{" "}
                                    </Nav.Link>
                                  </Nav.Item>
                                  
                                </Nav>
                              </Col>
                              <Col sm={12}>
                                <Tab.Content>
                                  <Tab.Pane eventKey="first">
                                    <PMoneyTransactions/>
                                  </Tab.Pane>

                                   <Tab.Pane eventKey="second">
                                    <Commissions/>
                                  </Tab.Pane>

                                  <Tab.Pane eventKey="third">
                                   <div className="row">
                                    <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                      <div className="text-center" style={{marginTop: "10px"}}>
                                        <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-dollar-sign mr-1"></i> <span className="counter">Deposit Insights</span></h3>
                                      </div>
                                      <div className="row">
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.deposit_volume}</span></h5>
                                            <p className="mb-2 text-dark"> Total Deposit Volume</p>

                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.conversion_rate}%</span></h5>
                                            <p className="mb-2 text-dark"> Deposit-to-Purchase Conversion</p>

                                          </div>
                                        </div>
                                        
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.largest_deposit?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Largest Single Deposit</p>
                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.average_deposit?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Average Deposit</p>
                                          </div>
                                        </div>
                                       
                                         <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_depositor?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Top Depositor</p>
                                            <p className="mb-2 text-dark"> UGX. {transactionHighlights?.top_depositor?.amount} deposited</p>
                                          </div>
                                        </div>
                                         <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.frequent_depositor?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Frequent Depositor</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.frequent_depositor?.number} deposits made</p>

                                          </div>
                                        </div>
                                         <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.deposit_day?.deposit_date?.short_date}</span></h5>
                                            <p className="mb-0 text-dark"> Record Deposit Day</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.deposit_day?.deposit_count?.total_c} deposits</p>

                                          </div>
                                        </div>
                                        
                                      </div>
                                      <div className="text-center" style={{marginTop: "10px"}}>
                                        <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-user mr-1"></i> <span className="counter">Top Vendors</span></h3>
                                      </div>
                                      <div className="row">
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_vendor_purchases?.user}</span></h5>
                                            <p className="mb-2 text-dark"> UGX. {transactionHighlights?.top_vendor_purchases?.amount} in purchases</p>

                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_vendor_cashouts?.user}</span></h5>
                                            <p className="mb-2 text-dark"> UGX. {transactionHighlights?.top_vendor_cashouts?.amount} in cashouts</p>

                                          </div>
                                        </div>
                                        
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_vendor_transactions?.user}</span></h5>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.top_vendor_transactions?.number} total transactions</p>
                                          </div>
                                        </div>
                                       
                                       <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_vendor_by_hour?.user}</span></h5>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.top_vendor_by_hour?.number} purchases within an hour</p>
                                          </div>
                                        </div>
                                       
                                         
                                        
                                      </div>
        
        
                                    </div>
                                    <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                      <div className="text-center" style={{marginTop: "10px"}}>
                                        <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-credit-card mr-1"></i><span className="counter">Purchase Insights</span></h3>
                                      </div>
                                      <div className="row">
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.purchase_volume}</span></h5>
                                            <p className="mb-2 text-dark"> Total Purchase Volume</p>
                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.cashout_volume}</span></h5>
                                            <p className="mb-2 text-dark"> Total Cashout Volume</p>
                                          </div>
                                        </div>
                                         <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.largest_purchase?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Largest Single Purchase</p>
                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">UGX. {transactionHighlights?.average_purchase?.total_c}</span></h5>
                                            <p className="mb-2 text-dark"> Average Purchase</p>
                                          </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.top_purchaser?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Top Buyer</p>
                                            <p className="mb-2 text-dark"> UGX. {transactionHighlights?.top_purchaser?.amount} in purchases</p>
                                          </div>
                                        </div>
                                         <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.frequent_purchaser?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Frequent Buyer</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.frequent_purchaser?.number} purchases made</p>

                                          </div>
                                          
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.consistent_purchaser?.user}</span></h5>
                                            <p className="mb-0 text-dark"> Consistent Buyer</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.consistent_purchaser?.streak_days} Day Streak <small>({transactionHighlights?.consistent_purchaser?.start_date?.short_date} - {transactionHighlights?.consistent_purchaser?.end_date?.short_date})</small></p>
                                          </div>
                                        </div>
                                         <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 ">
                                          <div className="text-center">
                                            <h5 className="mb-1 number-font"><span className="counter">{transactionHighlights?.purchase_day?.purchase_date?.short_date}</span></h5>
                                            <p className="mb-0 text-dark"> Record Purchase Day</p>
                                            <p className="mb-2 text-dark"> {transactionHighlights?.purchase_day?.purchase_count?.total_c} purchases</p>

                                          </div>
                                          
                                        </div>
                                         
                                      </div>
                                      
        
        
                                    </div>
                            
                            
                            
                            
                                  </div> 
                          
                                  </Tab.Pane>
                                </Tab.Content>
                              </Col>
                            </Row>
                          </Tab.Container>  
                        </div>
                      </div>
                  </div>
              </div>
     
    </AppContainer>
  );
}

export default PocketMoneyPage;